// Los errores de «Recibir bono» (paso 10) traducidos a lo que el vendedor tiene que HACER.
//
// Regla general del wizard: ante un error tipado se muestra el `msg` del silo, que viene en español
// (DEC-002). Este mapa es la excepción para los dos casos donde ese `msg` no alcanza.
import { ApiError } from '@/api/errors';
import { wizardErrorMsg } from './api/wizardError';

const FALLBACK = 'No se pudo activar la recarga — intenta de nuevo.';

/**
 * `PCF_ACCOUNT_MISSING` es terminal: el comprador no tiene cuenta donde depositar. Reintentar no
 * cambia nada, así que el mensaje lo dice y manda a reportarlo en vez de dejar al vendedor probando.
 *
 * `EXTERNAL_INTEGRATION_ERROR` trae en su `msg` el lambda de donde salió el fallo — diagnóstico
 * nuestro para CloudWatch, no algo que el vendedor pueda leer ni deba ver en el mostrador.
 */
const BY_CODE: Record<string, string> = {
    PCF_ACCOUNT_MISSING:
        'Este cliente no tiene cuenta PagoConFiado, así que no se le puede depositar el regalo. No sirve de nada reintentar: termina la venta sin la recarga y repórtalo con tu gerente.',
    EXTERNAL_INTEGRATION_ERROR:
        'No se pudo consultar la cuenta del cliente. Intenta de nuevo en un momento; si sigue igual, sal sin la recarga y queda en Pendientes.',
};

/** El mensaje que se le muestra al vendedor cuando falla la recarga de bienvenida. */
export function welcomeTopupErrorMsg(error: unknown): string {
    if (error instanceof ApiError && BY_CODE[error.code]) return BY_CODE[error.code];
    return wizardErrorMsg(error, FALLBACK);
}
